import { Injectable, inject } from "@angular/core";
import { remove } from "lodash";
import { BehaviorSubject, Observable } from "rxjs";
import { WebinstallningarService } from "../../../services/webinstallningar/webinstallningar.service";
import { INamedSearchFilter, ISavedSearchFilters } from "../model/INamedSearchFilter";
@Injectable({
    providedIn: "root"
})
export class SaveSearchFilterService {
    private readonly webinstallningarService = inject(WebinstallningarService);

    private readonly minaSokfilter$: BehaviorSubject<INamedSearchFilter[]> = new BehaviorSubject<INamedSearchFilter[]>([]);

    get minaSparadeFilter(): Observable<INamedSearchFilter[]> {
        return this.minaSokfilter$.asObservable();
    }

    getSavedFiltersInstallningar(webbInstallningKey: string) {
        this.webinstallningarService
            .getAsync(webbInstallningKey)
            .then((value: ISavedSearchFilters) => {
                if (value) {
                    this.minaSokfilter$.next(value.minaFilter);
                }
            });
    }
    nameIsUnique(filter: INamedSearchFilter) {
        return !this.minaSokfilter$.value || !this.minaSokfilter$.value.some(x => x.namn.toLowerCase().trim() === filter.namn.toLowerCase().trim());
    }

    updateSearchFilterByNamn(namedSearchFilter: INamedSearchFilter, webbinstallningarKey: string) {
        remove(this.minaSokfilter$.value, f => this.isEqualIgnoreCaseAndWhitespace(f.namn, namedSearchFilter.namn));
        this.saveSearchFilter(namedSearchFilter, webbinstallningarKey);
    }

    saveSearchFilter(namedSearchFilter: INamedSearchFilter, webbinstallningarKey: string) {
        this.webinstallningarService
            .setAsync(webbinstallningarKey, {
                minaFilter: [
                    ...this.minaSokfilter$.value,
                    ...[namedSearchFilter]
                ]
            })
            .then((result) => {
                this.getSavedFiltersInstallningar(webbinstallningarKey);
            });
    }

    saveLimitReached(maxSavedFilters: number) {
        return this.minaSokfilter$.value && this.minaSokfilter$.value.length >= maxSavedFilters;
    }

    deleteSearchFilterByNamn(namn: string, webbinstallningarKey: string) {
        remove(this.minaSokfilter$.value, f => this.isEqualIgnoreCaseAndWhitespace(f.namn, namn));

        this.webinstallningarService
            .setAsync(webbinstallningarKey, {
                minaFilter: this.minaSokfilter$.value
            })
            .then((result) => {
                this.getSavedFiltersInstallningar(webbinstallningarKey);
            });
    }

    private isEqualIgnoreCaseAndWhitespace(a: string, b: string): boolean {
        return a.trim().toLowerCase() === b.trim().toLowerCase();
    }
}
